import React, { ComponentProps } from 'react';
import { BarLoader } from 'react-spinners';
import Theme from 'App.theme';
import { PageSpinnerContainer } from './PageSpinner.styles';

type Props = ComponentProps<'div'>;

const PageSpinner: React.FC<Props> = ({ color, ...rest }) => {
  return (
    <PageSpinnerContainer {...rest}>
      <BarLoader color={color || Theme.colours.primary} />
    </PageSpinnerContainer>
  );
};

export default PageSpinner;
